var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMarkCircleOutline = function SvgQuestionMarkCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 22.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367",
    transform: "translate(-1261.084 -492.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7412",
    fill: "#687233",
    d: "M6.766-6.39a2.6 2.6 0 0 0-.241-1.144 2.6 2.6 0 0 0-.645-.86 2.8 2.8 0 0 0-.955-.542 3.6 3.6 0 0 0-1.17-.189 5 5 0 0 0-1.067.112 5.5 5.5 0 0 0-.912.284 4 4 0 0 0-.731.387 4.6 4.6 0 0 0-.525.4l.826 1.222a4.6 4.6 0 0 1 .9-.533 2.7 2.7 0 0 1 1.127-.241 1.7 1.7 0 0 1 1.058.336 1.17 1.17 0 0 1 .439.989 1.3 1.3 0 0 1-.12.585 1.5 1.5 0 0 1-.31.422 3 3 0 0 1-.422.336 5 5 0 0 0-.439.327 4.1 4.1 0 0 0-1 1.144 2.8 2.8 0 0 0-.344 1.4 5.2 5.2 0 0 0 .143 1.071H4a4 4 0 0 1-.052-.671 2.9 2.9 0 0 1 .249-1.179 2.47 2.47 0 0 1 .9-1.007q.189-.12.473-.327a3 3 0 0 0 .551-.525 3 3 0 0 0 .456-.757 2.6 2.6 0 0 0 .189-1.04M4.684 1.851A1.2 1.2 0 0 0 4.3.939a1.28 1.28 0 0 0-.9-.361 1.26 1.26 0 0 0-.921.361 1.22 1.22 0 0 0-.37.912 1.3 1.3 0 0 0 .37.938 1.2 1.2 0 0 0 .9.387 1.25 1.25 0 0 0 .929-.387 1.3 1.3 0 0 0 .376-.938",
    "data-name": "Path 7412",
    transform: "translate(1268.532 506.669)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_151",
    fill: "none",
    stroke: "#687233",
    strokeWidth: 1.5,
    "data-name": "Ellipse 151",
    transform: "translate(1261.084 492.416)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 11.25,
    r: 11.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 11.25,
    r: 10.5
  })))));
};
export default SvgQuestionMarkCircleOutline;